import { EmitterMixin, mix } from 'ckeditor5/src/utils';

export default class MnfEmitter {
	// Class's code.
	// ...
}

mix( MnfEmitter, EmitterMixin );
